import { createFileRoute } from '@tanstack/react-router'

import { BatchPage } from '@/pages/batch/Batch.page'

export const Route = createFileRoute(
  '/_auth/$companyId/spaces/$spaceId/projects/$projectId/batches/batch/$batchId',
)({
  component: BatchPage,
  loader: () => ({ breadcrumbTitle: 'Batch' }),
})
